import { render } from "./ReceiverDetails.vue?vue&type=template&id=64150e0c&scoped=true&ts=true"
import script from "./ReceiverDetails.vue?vue&type=script&lang=ts"
export * from "./ReceiverDetails.vue?vue&type=script&lang=ts"

import "./ReceiverDetails.vue?vue&type=style&index=0&id=64150e0c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64150e0c"]])

export default __exports__